import { gsap } from "gsap";

export default class TabHandler {
    private section: HTMLElement;
    private tabs: HTMLElement[] | null;
    private tabButtons: HTMLElement[] | null;

    constructor(section: HTMLElement) {
        this.section = section;
        this.tabs = [...this.section.querySelectorAll<HTMLElement>(".tabs-wrapper")];
        this.tabButtons = [...this.section.querySelectorAll<HTMLElement>(".tabs-name")];

        this.init();
    }

    public init = async (): Promise<void> => {
        this.tabButtons?.forEach((button) => {
            button.addEventListener("click", this.tabAnimation);
        });
    };

    private tabAnimation = async ({ currentTarget }): Promise<void> => {
        const currentBtnTab = currentTarget as HTMLElement;

        await this.easeOut(this.tabs);

        this.findActiveTab(currentBtnTab);

        const activeElement = this.tabs?.filter((item) => item.matches(".tabs-wrapper--visible")) as HTMLElement[];
        await this.easeIn(activeElement[0]);
    };

    private findActiveTab = async (currentBtnTab): Promise<void> => {
        this.tabs?.forEach((tab) => {
            tab.classList.remove("tabs-wrapper--visible");

            if (currentBtnTab.dataset.tabName === tab.dataset.tab) {
                this.removeAllButtonClasses();
                currentBtnTab.classList.add("tabs-name--active");

                tab.classList.add("tabs-wrapper--visible");
            }
        });
    };

    private removeAllButtonClasses = () => {
        this.tabButtons?.forEach((button) => {
            button.classList.remove("tabs-name--active");
        });
    };

    private easeOut = async (item): Promise<void> => {
        gsap.to(item, { opacity: 0, duration: 0.3 });
    };

    private easeIn = async (item): Promise<void> => {
        gsap.fromTo(item, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, delay: 0.3 });
    };
}
